const youtubeRegex =
    /(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/user\/\S+|\/ytscreeningroom\?v=|\/sandalsResorts#\w\/\w\/.*\/))([^\/&]{10,12})/;

const getYoutubePreviewImage = youtubeUrl => {
    if (
        youtubeUrl &&
        youtubeUrl.match(youtubeRegex) &&
        youtubeUrl.match(youtubeRegex)[1]
    ) {
        const imageUrl = `https://img.youtube.com/vi/${
            youtubeUrl.match(youtubeRegex)[1]
        }/hqdefault.jpg`;
        // updated since not all videos have maxres https://adrenalinmedia.atlassian.net/browse/AUTS-1969

        return imageUrl;
    } else {
        return "";
    }
};

export default getYoutubePreviewImage;
